<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { onReachBottom } from '@dcloudio/uni-app'
import ProductItem from './product-item.vue'
import { getActivityList } from '@/api/activity'

const activityList = ref<any>([])
const params = ref({
  pageSize: 7,
  pageNum: 1,
})

const total = ref(0)

async function loadData() {
  if (total.value === activityList.value.length && params.value.pageNum !== 1) {
    uni.showToast({
      title: '已经到底了',
      duration: 2000,
      icon: 'none',
    })
    return
  }

  try {
    const res: any = await getActivityList(params.value)
    activityList.value = [...activityList.value, ...res.records]
    activityList.value = activityList.value.map((item: any) => {
      item.code = 'HD231114038'
      item.name = '中国移动'
      item.coverImage = 'https://c3b3-hasten.xmonecode.com/tc/e28da88b-621b-4a6f-a73e-c960d235cfa1_1020x930.jpeg'
      return item
    })
    total.value = res.total
    params.value.pageNum += 1
  }
  catch (e) {}
}

function onByteHi(res) {
  console.log('res: ', res)
}

onReachBottom(loadData)
onMounted(loadData)
</script>

<template>
<!--  -->





















</template>

<style scoped>
.main {
  background-color: #f3f3f3;
  padding-top: 14rpx;
  padding-bottom: 30rpx;
}
</style>
